import {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {useDeleteMyHouse} from "../stores/houseStore";
import HouseGallery from "./HouseGallery";
import {useGetHouseById, useHouse} from "../stores/otherStore";
import Seo from "../utils/Seo";

const HouseDetail = () => {
    const [showConfirm, setShowConfirm] = useState(false);
    const house = useHouse();
    const {id} = useParams();
    const navigate = useNavigate();
    const token = localStorage.getItem("access_token");
    const getHouseById = useGetHouseById();
    const deleteMyHouse = useDeleteMyHouse();

    const user = JSON.parse(localStorage.getItem("user") || "{}");
    useEffect(() => {
        if (!id) return;

        const fetchHouse = async () => {
            console.log("Запрос за домом:", id);
            await getHouseById(id);
        };

        fetchHouse();
    }, [id, getHouseById]);
    const handleDelete = async (id) => {
        const success = await deleteMyHouse(id, token);
        if (success) {
            navigate("/detail/profile");
        }
    };

    useEffect(() => {
        window.scrollTo({top: 0, behavior: 'smooth'});
    }, []);
    if (!house) {
        return <div>Загрузка...</div>;
    }

    const currentUrl = typeof window !== 'undefined' ? window.location.href : '';
    const imageUrl = house.images && house.images.length > 0 ? house.images[0].image : '/image.png';

    const structuredData = {
        "@context": "https://schema.org",
        "@type": "RealEstateListing",
        "name": house.title,
        "description": house.description,
        "url": currentUrl,
        "image": imageUrl,
        "address": {
            "@type": "PostalAddress",
            "streetAddress": house.address,
            "addressLocality": house.district,
            "addressCountry": "KG"
        },
        "offers": {
            "@type": "Offer",
            "price": house.price_usd,
            "priceCurrency": "USD",
            "availability": "https://schema.org/InStock"
        },
        "numberOfRooms": house.rooms,
        "floorSize": {
            "@type": "QuantitativeValue",
            "value": house.area_total_m2,
            "unitCode": "MTK"
        }
    };

    return (
        <>
            <Seo
                title={`${house.title} — ${house.category.name} в ${house.district} | Aluu Satuu`}
                description={`${house.category.name} в ${house.district}. ${house.description || ''} Площадь: ${house.area_total_m2 || 'не указана'} м². Цена: ${house.price_usd?.toLocaleString()} USD. ${house.contacts || 'Звоните для уточнения деталей.'}`}
                url={currentUrl}
                image={imageUrl}
                type="article"
                structuredData={structuredData}
            />
            <div className={'py-5 bg-center bg-cover'}
                 style={{backgroundImage: `url(https://images.wallpaperscraft.ru/image/single/zdanie_neboskreb_arhitektura_223682_1400x1050.jpg)`}}>
                <div className="max-w-5xl mx-auto p-6 bg-white/20 backdrop-blur-lg rounded-xl shadow-lg">
                {/* Заголовок и категория */}
                <div className="mb-2">
                    <h1 className="text-4xl font-bold text-black mb-2">{house.title}</h1>
                    <p className="text-gray-600 text-lg">{house.category.name} | {house.district}</p>
                    <div className="flex gap-6 text-xl font-semibold">
                        <span className="text-blue-700">{house.price_usd?.toLocaleString()} USD</span>
                        <span className="text-green-700">{house.price_som?.toLocaleString()} сом</span>
                    </div>
                </div>
                {/* Медиа */}
                {house && <HouseGallery house={house} onUpdate={() => getHouseById(id)}/>}
                {/* Основная информация */}
                <section className="grid grid-cols-2 gap-4 my-6">
                    {house.area_total_m2 && <div className="p-4 bg-white/30 backdrop-blur-md rounded-lg">Площадь: <span
                        className="font-semibold">{house.area_total_m2} м²</span></div>}
                    {house.floor && <div className="p-4 bg-white/30 backdrop-blur-md rounded-lg">Этаж: <span
                        className="font-semibold">{house.floor}/{house.floors_total || "-"}</span></div>}
                    {house.rooms && <div className="p-4 bg-white/30 backdrop-blur-md rounded-lg">Комнат: <span
                        className="font-semibold">{house.rooms}</span></div>}
                    {house.land_area_sotka > 0 &&
                        <div className="p-4 bg-white/30 backdrop-blur-md rounded-lg">Участок: <span
                            className="font-semibold">{house.land_area_sotka} соток</span></div>}
                    {house.year_built > 0 &&
                        <div className="p-4 bg-white/30 backdrop-blur-md rounded-lg">Год постройки: <span
                            className="font-semibold">{house.year_built}</span></div>}
                </section>

                {/* Характеристики */}
                <section className="grid grid-cols-2 gap-4 mb-6">
                    {house.apartment_series && <div className="p-4 bg-white/30 backdrop-blur-md rounded-lg">Серия: <span
                        className="font-semibold">{house.apartment_series.name}</span></div>}
                    {house.construction_type &&
                        <div className="p-4 bg-white/30 backdrop-blur-md rounded-lg">Тип постройки: <span
                            className="font-semibold">{house.construction_type.name}</span></div>}
                    {house.heating && <div className="p-4 bg-white/30 backdrop-blur-md rounded-lg">Отопление: <span
                        className="font-semibold">{house.heating.name}</span></div>}
                    {house.furniture && <div className="p-4 bg-white/30 backdrop-blur-md rounded-lg">Мебель: <span
                        className="font-semibold">{house.furniture.name}</span></div>}
                    {house.repair_type && <div className="p-4 bg-white/30 backdrop-blur-md rounded-lg">Ремонт: <span
                        className="font-semibold">{house.repair_type.name}</span></div>}
                </section>

                {/* Описание */}
                {house.description && (
                    <section className="mb-6 p-6 bg-white/20 backdrop-blur-md rounded-lg">
                        <h2 className="text-2xl font-semibold mb-2">Описание</h2>
                        <p>{house.description}</p>
                    </section>
                )}
                {house.purpose && (
                    <section className="mb-6 p-6 bg-white/20 backdrop-blur-md rounded-lg">
                        <h2 className="text-2xl font-semibold mb-2">Целевое
                            назначение</h2>
                        <p>{house.purpose}</p>
                    </section>
                )}
                {house.communications && (
                    <section className="mb-6 p-6 bg-white/20 backdrop-blur-md rounded-lg">
                        <h2 className="text-2xl font-semibold mb-2">Коммуникация</h2>
                        <p>{house.communications}</p>
                    </section>
                )}

                {/* Контакты */}
                {house.contacts && (
                    <section className="mb-6 p-6 bg-white/20 backdrop-blur-md rounded-lg">
                        <h2 className="text-2xl font-semibold mb-2">Контакты</h2>
                        <p>{house.contacts}</p>
                    </section>
                )}
                <div className="flex justify-between">
                    {house.owner_id === user.id && (
                        <button
                            onClick={() => setShowConfirm(true)}
                            className="bg-red-600/40 p-2 text-black/70 duration-150 rounded-lg hover:bg-red-600/50"
                        >
                            Удалить
                        </button>
                    )}

                    {showConfirm && (
                        <div className="fixed inset-0 flex items-end justify-center py-20 bg-black/50 z-50">
                            <div className="bg-gray-300 rounded-lg shadow-lg p-6 w-[300px]">
                                <h2 className="text-lg font-semibold text-gray-800 mb-4">
                                    Вы уверены, что хотите удалить объявление?
                                </h2>
                                <div className="flex justify-end gap-3">
                                    <button
                                        onClick={() => setShowConfirm(false)}
                                        className="px-4 py-2 bg-gray-400 rounded-lg hover:bg-gray-500"
                                    >
                                        Отмена
                                    </button>
                                    <button
                                        onClick={() => {
                                            handleDelete(house.id);
                                            setShowConfirm(false);
                                        }}
                                        className="px-4 py-2 bg-red-600/60 text-white rounded-lg hover:bg-red-600/65"
                                    >
                                        Удалить
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                    {house.owner_id === user.id && (
                        <button onClick={() => navigate(`/detail/update/${house.id}`)}
                            className={'bg-blue-600/40 p-2 text-black/70 duration-150 rounded-lg hover:bg-blue-600/50'}>Обновить</button>
                    )}
                </div>
            </div>
        </div>
        </>
    );
};

export default HouseDetail;
